AppTabs.createTab( {
name: 'test-methods',
icon: 'list-alt',
text: 'Test Methods',
create: function(init) {
	'use strict'

	init.setDataTableArgs( {

		tableId: 		'#data-table-test-methods',

		readTableName: 	'tblTestMethods',
		editTableName: 	'tblTestMethods',
		primaryKey: 	'TestMethodID',

		hasColumnFilters: 	true,
		canSearch:          true,
		canSort:			true,
		paging:				false,

		actionData:			'datatable',
		actionCreate:		'datatable_create',
		actionEdit:			'datatable_edit',
		actionRemove:		'datatable_remove',

		fields: [
			{
				label: 		'Method',
				columnName: 'Method',
				isEditable: true,
				order: 		'asc',
			},
			{
				label: 		'EQUIS Report',
				columnName: 'Equis',
				isEditable: true,
			},
		],

	} );
}

} );
